<template>
  <div>
    <el-row :gutter="10">
      <!-- ==================== executar carga ==================== -->
      <el-col :xs="24" :sm="12">
        <c-panel title="Executar carga" titleIcon="fas fa-database">
          <el-form label-position="top" size="small">
            <el-form-item label="Data de referência">
              <el-date-picker v-model="dataReferencia" type="date" value-format="yyyy-MM-dd"
                              placeholder="hoje, se vazio" style="width:100%"></el-date-picker>
            </el-form-item>

            <!-- origem 1: base operacional -->
            <el-form-item label="Origem interna (base operacional do SMGE)">
              <el-select v-model="dominio" placeholder="domínio" style="width:60%">
                <el-option v-for="d in dominios" :key="d" :label="d" :value="d"></el-option>
              </el-select>
              <el-button type="primary" size="small" :loading="executando" class="u-ml-5"
                         @click="executarInterna" data-test="btn-carga-interna">EXECUTAR</el-button>
            </el-form-item>

            <!-- origem 2: arquivo de intercâmbio -->
            <el-form-item label="Origem arquivo de intercâmbio (CSV)">
              <input ref="arquivo" type="file" accept=".csv,text/csv" data-test="input-arquivo" />
              <el-button type="primary" size="small" :loading="enviandoArquivo" class="u-mt-5"
                         @click="enviarArquivo" data-test="btn-carga-arquivo">ENVIAR ARQUIVO</el-button>
              <div class="obs">Layout versionado — ver <code>layout-intercambio.md</code>.</div>
            </el-form-item>

            <!-- origem 3: endpoint HTTP -->
            <el-form-item label="Origem HTTP (sistema externo)">
              <el-input v-model="urlHttp" placeholder="https://parceiro/dados" size="small"></el-input>
              <el-button type="primary" size="small" :loading="executandoHttp" class="u-mt-5"
                         @click="executarHttp" data-test="btn-carga-http">BUSCAR</el-button>
              <div class="obs">Só hosts autorizados em <code>BI_HTTP_HOSTS</code>.</div>
            </el-form-item>
          </el-form>

          <el-alert v-if="resultado" :type="resultado.rejeitadas > 0 ? 'warning' : 'success'"
                    :closable="false" show-icon class="u-mt-10" data-test="resultado-carga">
            <div slot="title">
              Carga #{{ resultado.carga_id }} ({{ resultado.origem }}) —
              {{ resultado.gravadas }} de {{ resultado.lidas }} linhas gravadas
            </div>
            <div v-if="resultado.rejeitadas > 0" class="obs">
              {{ resultado.rejeitadas }} rejeitadas —
              <el-button type="text" size="mini" @click="verErros(resultado.carga_id)">ver motivos</el-button>
            </div>
          </el-alert>

          <el-alert v-if="erro" type="error" :closable="false" show-icon class="u-mt-10"
                    data-test="erro-carga" :title="erro"></el-alert>
        </c-panel>
      </el-col>

      <!-- ==================== linhagem (BI 15) ==================== -->
      <el-col :xs="24" :sm="12">
        <c-panel title="Linhagem — de onde vêm os números" titleIcon="fas fa-project-diagram">
          <div v-if="carregandoLinhagem" class="estado"><i class="el-icon-loading"></i> carregando…</div>
          <div v-else-if="erroLinhagem" class="estado erro">{{ erroLinhagem }}</div>
          <template v-else>
            <el-row :gutter="8" class="u-mb-10">
              <el-col :span="8"><div class="cartao">
                <div class="cartao-rotulo">Origens distintas</div>
                <div class="cartao-valor" data-test="origens-distintas">{{ resumo.origens_distintas || 0 }}</div>
              </div></el-col>
              <el-col :span="8"><div class="cartao">
                <div class="cartao-rotulo">Externas ao SMGE</div>
                <div class="cartao-valor" data-test="origens-externas">{{ resumo.origens_externas || 0 }}</div>
              </div></el-col>
              <el-col :span="8"><div class="cartao">
                <div class="cartao-rotulo">Fatos no repositório</div>
                <div class="cartao-valor">{{ resumo.total_fatos || 0 }}</div>
              </div></el-col>
            </el-row>

            <div v-if="!linhagem.length" class="estado" data-test="linhagem-vazia">
              Nenhuma carga executada ainda.
            </div>
            <table v-else class="table table-striped" data-test="tabela-linhagem">
              <thead><tr><th>Domínio</th><th>Origem</th><th>Fatos</th><th>Última carga</th></tr></thead>
              <tbody>
                <template v-for="d in linhagem">
                  <tr v-for="(f, i) in d.fontes" :key="d.dominio + '-' + i">
                    <td>{{ i === 0 ? d.dominio : '' }}</td>
                    <td>
                      <el-tag size="mini" :type="f.origem === 'interna' ? 'info' : 'success'">
                        {{ f.origem }}
                      </el-tag>
                      <div class="ref" v-if="f.referencia">{{ f.referencia }}</div>
                    </td>
                    <td>{{ f.fatos }}</td>
                    <td>{{ f.ultima_carga || '—' }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </template>
        </c-panel>
      </el-col>
    </el-row>

    <!-- ==================== histórico ==================== -->
    <c-panel title="Histórico de cargas" titleIcon="fas fa-history" class="u-mt-10">
      <div v-if="carregandoHistorico" class="estado"><i class="el-icon-loading"></i> carregando…</div>
      <div v-else-if="!historico.length" class="estado">Nenhuma carga registrada.</div>
      <table v-else class="table table-striped" data-test="tabela-historico">
        <thead><tr><th>#</th><th>Origem</th><th>Domínio</th><th>Referência</th>
                   <th>Lidas</th><th>Gravadas</th><th>Rejeitadas</th><th>Status</th><th></th></tr></thead>
        <tbody>
          <tr v-for="c in historico" :key="c.id">
            <td>{{ c.id }}</td>
            <td><el-tag size="mini" :type="c.origem === 'interna' ? 'info' : 'success'">{{ c.origem }}</el-tag></td>
            <td>{{ c.dominio }}</td>
            <td>{{ c.data_referencia }}</td>
            <td>{{ c.linhas_lidas }}</td>
            <td>{{ c.linhas_gravadas }}</td>
            <td :class="{ 'tem-erro': c.linhas_rejeitadas > 0 }">{{ c.linhas_rejeitadas }}</td>
            <td>{{ c.status }}</td>
            <td>
              <el-button v-if="c.linhas_rejeitadas > 0" type="text" size="mini"
                         @click="verErros(c.id)">erros</el-button>
              <el-button class="u-ml-10" type="text" size="mini" @click="verConteudo(c.id)"
                         data-test="btn-conteudo">conteúdo</el-button>
            </td>
          </tr>
        </tbody>
      </table>
    </c-panel>

    <el-dialog title="Conteúdo da carga" :visible.sync="dialogConteudo" width="560px" append-to-body>
      <div v-if="cargaDetalhe" class="obs u-mb-5">
        Carga #{{ cargaDetalhe.id }} · origem {{ cargaDetalhe.origem }} ·
        {{ cargaDetalhe.referencia || 'base operacional' }}
      </div>
      <table class="table table-striped" data-test="tabela-conteudo">
        <thead><tr><th>Domínio</th><th>Métrica</th><th>Fatos</th><th>Soma</th></tr></thead>
        <tbody>
          <tr v-for="(c, i) in conteudoCarga" :key="i">
            <td>{{ c.dominio }}</td><td>{{ c.metrica }}</td>
            <td>{{ c.fatos }}</td><td>{{ c.soma }}</td>
          </tr>
        </tbody>
      </table>
    </el-dialog>

    <el-dialog title="Linhas rejeitadas" :visible.sync="dialogErros" width="560px" append-to-body>
      <p class="obs">Linha inválida não aborta a carga: o que é válido entra, o resto vem aqui.</p>
      <table class="table table-striped" data-test="tabela-erros">
        <thead><tr><th style="width:80px">Linha</th><th>Motivo</th></tr></thead>
        <tbody>
          <tr v-for="(e, i) in errosCarga" :key="i"><td>{{ e.linha }}</td><td>{{ e.motivo }}</td></tr>
        </tbody>
      </table>
    </el-dialog>
  </div>
</template>

<script>
/**
 * FASE 5 / BLOCO BA-4 — BI 1, 14 e 15.
 *
 * Carga do repositório analítico e linhagem, pela tela.
 *
 * É esta tela que torna o passo P22 da POC executável sem terminal: as três origens
 * (interna, arquivo de intercâmbio e HTTP) são disparadas por botão, e a convergência delas
 * — a prova do BI 15 — aparece no painel de linhagem, com a contagem de origens externas.
 */
import biApi from '../biApi'

export default {
  data () {
    return {
      api: null,
      dominios: ['matricula', 'aluno', 'servidor', 'inscricao'],
      dominio: 'matricula',
      dataReferencia: null,
      urlHttp: '',
      resultado: null,
      erro: null,
      executando: false,
      enviandoArquivo: false,
      executandoHttp: false,
      linhagem: [],
      resumo: {},
      carregandoLinhagem: false,
      erroLinhagem: null,
      historico: [],
      carregandoHistorico: false,
      dialogErros: false,
      errosCarga: [],
      dialogConteudo: false,
      conteudoCarga: [],
      cargaDetalhe: null
    }
  },

  mounted () {
    this.api = biApi.criar({ axios: this.$axios, base: this.base(), auth: this.auth() })
    this.carregarLinhagem()
    this.carregarHistorico()
  },

  methods: {
    base () { return this.$store.state.config.baseUrlApi },
    auth () { return this.$store.getters.getHeaderAuth },

    /**
     * Normaliza o erro que a API devolve.
     *
     * ARMADILHA REAL deste backend: negativa de permissão vem com HTTP **200** e corpo
     * `{erro: {cod: 800, text: '...'}}` — não com 403. Tratar só `status === 403` nunca
     * dispararia, e atribuir `d.erro` direto renderizaria "[object Object]" na tela.
     * O interceptor global de `main.js` já redireciona 800/801 para `/not-permission`;
     * isto cobre os demais casos e o texto exibido.
     */
    textoErro (erro) {
      if (!erro) return null
      if (typeof erro === 'string') return erro
      if (erro.text) return erro.text
      if (erro.message) return erro.message
      return 'Não foi possível concluir a operação.'
    },

    mensagemErro (e) {
      const r = e && e.response ? e.response : null
      if (!r) return 'Falha de comunicação com o servidor.'
      if (r.status === 403) return 'Você não tem autorização para executar cargas.'
      if (r.data && r.data.erro) return this.textoErro(r.data.erro)
      return 'Erro ' + r.status + ' ao consultar o servidor.'
    },

    aplicar (r) {
      this.resultado = null
      this.erro = null
      const d = r.data || {}
      if (d.erro) { this.erro = this.textoErro(d.erro); return }
      this.resultado = d
      this.carregarLinhagem()
      this.carregarHistorico()
    },

    executarInterna () {
      if (this.executando) return           // duplo clique não dispara duas cargas
      const self = this
      this.executando = true
      this.api.executarCarga(this.dominio, this.dataReferencia).then(function (r) {
        self.executando = false
        self.aplicar(r)
      }).catch(function (e) {
        self.executando = false
        self.erro = self.mensagemErro(e)
      })
    },

    enviarArquivo () {
      if (this.enviandoArquivo) return
      const input = this.$refs.arquivo
      if (!input || !input.files || !input.files.length) {
        this.erro = 'Selecione um arquivo CSV.'
        return
      }
      const self = this
      this.enviandoArquivo = true

      const fd = new FormData()
      fd.append('arquivo', input.files[0])
      if (this.dataReferencia) fd.append('data_referencia', this.dataReferencia)

      this.api.uploadCarga(fd).then(function (r) {
        self.enviandoArquivo = false
        input.value = ''                    // não reenvia o mesmo arquivo sem querer
        self.aplicar(r)
      }).catch(function (e) {
        self.enviandoArquivo = false
        self.erro = self.mensagemErro(e)
      })
    },

    executarHttp () {
      if (this.executandoHttp) return
      if (!this.urlHttp) { this.erro = 'Informe a URL do endpoint.'; return }
      const self = this
      this.executandoHttp = true
      this.api.cargaHttp(this.urlHttp, this.dataReferencia).then(function (r) {
        self.executandoHttp = false
        self.aplicar(r)
      }).catch(function (e) {
        self.executandoHttp = false
        self.erro = self.mensagemErro(e)
      })
    },

    carregarLinhagem () {
      const self = this
      this.carregandoLinhagem = true
      this.erroLinhagem = null
      this.api.linhagem(null).then(function (r) {
        const d = r.data || {}
        self.linhagem = d.dominios || []
        self.resumo = d.resumo || {}
        self.carregandoLinhagem = false
      }).catch(function (e) {
        self.carregandoLinhagem = false
        self.erroLinhagem = self.mensagemErro(e)
      })
    },

    carregarHistorico () {
      const self = this
      this.carregandoHistorico = true
      this.api.historicoCargas({}).then(function (r) {
        const d = r.data || {}
        self.historico = d.data || d || []
        self.carregandoHistorico = false
      }).catch(function () {
        self.carregandoHistorico = false
        self.historico = []
      })
    },

    /** O que aquela carga trouxe, por domínio e métrica — linhagem da carga (BI 15). */
    verConteudo (id) {
      const self = this
      this.$axios.get(this.base() + '/api/bi-linhagem/porCarga/' + id, this.auth())
        .then(function (r) {
          self.conteudoCarga = (r.data && r.data.conteudo) || []
          self.cargaDetalhe = (r.data && r.data.carga) || null
          self.dialogConteudo = true
        })
    },

    verErros (id) {
      const self = this
      this.api.errosCarga(id).then(function (r) {
        self.errosCarga = (r.data && r.data.erros) || []
        self.dialogErros = true
      })
    }
  }
}
</script>

<style scoped>
.estado { padding: 16px; text-align: center; color: #909399; font-size: 12px; }
.estado.erro { color: #F56C6C; }
.cartao { background: #f5f7fa; border-radius: 4px; padding: 10px; text-align: center; }
.cartao-rotulo { font-size: 11px; color: #909399; }
.cartao-valor { font-size: 22px; font-weight: 600; }
.obs { font-size: 11px; color: #909399; }
.ref { font-size: 10px; color: #909399; word-break: break-all; }
.tem-erro { color: #E6A23C; font-weight: 600; }
</style>
